import { pad } from '@/utils/helpers/StringsNumbers'
import { getSimpleDate, getSimpleDateWithNextBusinessDay } from '../utils/helpers/FormatDate'

export const positivePayMixins = {
  methods: {
    // Create a CSV file for City National Bank (Delimited Format)
    // Array keys will be the column headers
    createCnb (data, bank, map) {
      // This is the final output
      let csv = ''

      // This is the delimited template
      if (!map) {
        map = [
          {
            name: 'account_number',
            length: 9,
            data: bank.account_number,
            pad: null
          },
          {
            name: 'check_number',
            length: 10,
            data: ['payment_confirmation_number', 'number'],
            pad: null
          },
          {
            name: 'check_amount',
            length: 10,
            data: ['amount', 'amount_decimal'],
            pad: null,
            function: (value) => {
              return (value || '').replace(/[^0-9.]/g, '')
            }
          },
          {
            name: 'issue_date',
            length: 8,
            data: ['payment_date', 'date'],
            pad: null,
            function: (value) => {
              const date = getSimpleDate(value)
              return date.substr(4, 2) + '/' + date.substr(6, 2) + '/' + date.substr(2, 2)
            }
          },
          {
            name: 'payee_name',
            length: 50,
            data: ['payee_name', 'vendor_name'],
            pad: null,
            function: (value) => {
              return `"${value}"`
            }
          },
          {
            name: 'record_indicator',
            length: 1,
            data: 'status',
            pad: null,
            function: (value) => {
              if ((value || '').toLowerCase() === 'voided') {
                return 'V'
              } else {
                return 'I'
              }
            }
          }
        ]
      }

      // Now build data rows
      for (const i in data) {
        // If AP, only return checkdata, not wires
        // if (!data.account_cash && !(data[i].payment_type || '').toLowerCase().match(/check/)) continue

        let line = ''

        // Go through the mapping and transform data if necessary
        for (const j in map) {
          const field = map[j]
          // let value = this.coalesceArray([field.data], data[i]) || this.coalesceArray(field.data) || field.default || ''

          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, data[i]) : data[i][field.data]) || (field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          line += pad(value, field.pad || '', field.length, field.justify)
          if (parseInt(j) < (map.length - 1)) line += ','
        }
        line += '\r\n'
        csv += line
      }

      return csv
    },

    // Create a CSV file for City National Bank (Delimited Format)
    // Array keys will be the column headers
    createCnbOld (data, bank, map) {
      // This is the final output
      let csv = ''

      // This is the delimited template
      if (!map) {
        map = [
          {
            name: 'bank_number',
            length: 3,
            pad: null,
            default: 309
          },
          {
            name: 'account_number',
            length: 9,
            data: bank.account_number,
            pad: null
          },
          {
            name: 'check_number',
            length: 8,
            data: ['payment_confirmation_number', 'number'],
            pad: '0'
          },
          {
            name: 'check_amount',
            length: 10,
            data: ['amount', 'amount_decimal'],
            pad: '0',
            function: (value) => {
              return (value || '').replace(/\D/g, '')
            }
          },
          {
            name: 'issue_date',
            length: 6,
            data: ['payment_date', 'date'],
            pad: null,
            function: (value) => {
              const date = getSimpleDate(value)
              return date.substr(4, 2) + date.substr(6, 2) + date.substr(2, 2)
            }
          },
          {
            name: 'payee_name',
            length: 50,
            data: ['payee_name', 'vendor_name'],
            pad: ' ',
            justify: 'left'
          },
          {
            name: 'record_indicator',
            length: 1,
            data: 'status',
            pad: null,
            function: (value) => {
              if ((value || '').toLowerCase() === 'voided') {
                return 'V'
              } else {
                return 'I'
              }
            }
          }
        ]
      }

      // Now build data rows
      for (const i in data) {
        // If AP, only return checkdata, not wires
        // if (!data.account_cash && !(data[i].payment_type || '').toLowerCase().match(/check/)) continue

        let line = ''

        // Go through the mapping and transform data if necessary
        for (const j in map) {
          const field = map[j]
          // let value = this.coalesceArray([field.data], data[i]) || this.coalesceArray(field.data) || field.default || ''

          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, data[i]) : data[i][field.data]) || (field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          line += pad(value, field.pad || '', field.length, field.justify)
        }
        line += '\r\n'
        csv += line
      }

      return csv
    },

    // Create a CSV file for City National Bank (FixedWidth Format)
    // Array keys will be the column headers
    createCnbFixed (data, bank, map) {
      // This is the final output
      let output = ''

      // This is the fixed width template
      if (!map) {
        map = [
          {
            name: 'bank_number',
            length: 3,
            pad: null,
            default: 'CNB'
          },
          {
            name: 'account_number',
            length: 9,
            data: bank.account_number,
            pad: null
          },
          {
            name: 'check_number',
            length: 8,
            data: ['payment_confirmation_number', 'number'],
            pad: '0'
          },
          {
            name: 'check_amount',
            length: 10,
            data: ['amount', 'amount_decimal'],
            pad: '0',
            function: (value) => {
              return (value || '').replace(/\D/g, '')
            }
          },
          {
            name: 'issue_date',
            length: 6,
            data: ['payment_date', 'date'],
            pad: null,
            function: (value) => {
              const date = getSimpleDate(value)
              return date.substr(4, 2) + date.substr(6, 2) + date.substr(2, 2)
            }
          },
          {
            name: 'payee_name',
            length: 50,
            data: ['payee_name', 'vendor_name'],
            pad: ' ',
            justify: 'left'
          },
          {
            name: 'record_indicator',
            length: 1,
            data: 'status',
            pad: null,
            function: (value) => {
              if ((value || '').toLowerCase() === 'voided') {
                return 'V'
              } else {
                return 'I'
              }
            }
          }
        ]
      }

      // Now build data rows
      for (const i in data) {
        // If AP, only return checkdata, not wires
        // if (!data.account_cash && !(data[i].payment_type || '').toLowerCase().match(/check/)) continue

        let line = ''

        // Go through the mapping and transform data if necessary
        for (const j in map) {
          const field = map[j]
          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, data[i]) : data[i][field.data]) || (field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          line += pad(value, field.pad || '', field.length, field.justify)
        }
        line += '\r\n'
        output += line
      }

      return output
    },

    // Creating a file for JP morgan chase ARP
    createArpFixed (data, bank, map) {
      // This is the final output
      let output = ''

      // This is the fixed width template
      if (!map) {
        map = [
          {
            name: 'record_indicator',
            length: 1,
            data: 'status',
            pad: '',
            filler: 1,
            function: (value) => {
              if ((value || '').toLowerCase() === 'voided') {
                return 'V'
              } else {
                return 'O'
              }
            }
          },
          {
            name: 'account_number',
            length: 20,
            data: bank.account_number,
            pad: '0',
            justify: 'right',
            filler: 1
          },
          {
            name: 'check_number',
            length: 18,
            data: ['payment_confirmation_number', 'number'],
            pad: '0',
            justify: 'right',
            filler: 1
          },
          {
            name: 'check_amount',
            length: 18,
            data: ['amount', 'amount_decimal'],
            pad: '0',
            justify: 'right',
            filler: 1,
            function: (value) => {
              return String(value || '').replace(/\D/g, '')
            }
          },
          {
            name: 'issue_date',
            length: 8,
            data: ['payment_date', 'date'],
            pad: ' ',
            justify: 'right',
            filler: 1,
            function: (value) => {
              const date = getSimpleDate(new Date())
              return date.substr(0, 4) + date.substr(4, 2) + date.substr(6, 2)
            }
          },
          {
            name: 'paid_date',
            length: 8,
            data: ['payment_date', 'date'],
            pad: ' ',
            justify: 'right',
            filler: 1,
            function: (value) => {
              const date = getSimpleDate(value)
              return date.substr(0, 4) + date.substr(4, 2) + date.substr(6, 2)
            }
          },
          {
            name: 'additional_data',
            length: 15,
            pad: ' '
          },
          {
            name: 'payee_name',
            length: 50,
            data: ['payee_name', 'vendor_name'],
            pad: ' ',
            justify: 'left'
          },
          {
            name: 'vendor_alias_name',
            length: 50,
            data: '',
            pad: ' ',
            justify: 'left',
            filler: 6,
            default: ''
          }
          // {
          //   name: 'record_indicator',
          //   length: 1,
          //   data: 'status',
          //   pad: null,
          //   function: (value) => {
          //     if ((value || '').toLowerCase() === 'voided') {
          //       return 'V'
          //     } else {
          //       return 'I'
          //     }
          //   }
          // }
        ]
      }

      // Now build data rows
      for (const i in data) {
        // If AP, only return checkdata, not wires
        // if (!data.account_cash && !(data[i].payment_type || '').toLowerCase().match(/check/)) continue

        let line = ''

        // Go through the mapping and transform data if necessary
        for (const j in map) {
          const field = map[j]
          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, data[i]) : data[i][field.data]) || (field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          value = (value === 'vendor_alias_name') ? '' : value
          let padded = pad(value, field.pad || '', (field.length), field.justify)
          if (padded && field.filler) {
            padded = padded.padEnd(field.length + field.filler)
          }
          line += padded
        }
        line += '\r\n'
        output += line
      }

      return output
    },

    // Create a FIXED WIDTH file for Union Bank
    // Array keys will be the column headers
    createUnion (data, bank, map) {
      // if (!data || !Array.isArray(data)) return false

      // This is the final output
      let csv = ''

      // This is the fixed width template
      if (!map) {
        map = [
          {
            name: 'check_number',
            data: ['payment_confirmation_number', 'number'],
            pad: '0'
          },
          {
            name: 'issue_date',
            length: 8,
            data: ['payment_date', 'date'],
            pad: null,
            function: (value) => {
              const date = getSimpleDate(value)
              return date.substr(4, 2) + '/' + date.substr(6, 2) + '/' + date.substr(2, 2)
            }
          },
          {
            name: 'check_amount',
            data: ['amount', 'amount_decimal']
          },
          {
            name: 'record_indicator',
            length: 1,
            data: 'status',
            pad: null,
            function: (value) => {
              if ((value || '').toLowerCase() === 'voided') {
                return 'C'
              } else {
                return 'I'
              }
            }
          }
        ]
      }

      // Now build data rows
      for (const i in data) {
        // If AP, only return checkdata, not wires
        // if (!data.account_cash && !(data[i].payment_type || '').toLowerCase().match(/check/)) continue

        let line = ''

        // Go through the mapping and transform data if necessary
        for (const j in map) {
          const field = map[j]
          // let value = this.coalesceArray([field.data], data[i]) || this.coalesceArray(field.data) || field.default || ''

          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, data[i]) : data[i][field.data]) || (field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          line += pad(value, field.pad || '', field.length, field.justify)
          if (parseInt(j) < (map.length - 1)) line += ','
        }
        line += '\r\n'
        csv += line
      }

      return csv
    },

    // Creating a file for CDS Delimted Text File
    createCds (data, bank, map) {
      // This is the final output
      let output = ''

      // This is the fixed width template
      if (!map) {
        map = [
          {
            name: 'record_indicator',
            length: 1,
            data: 'status',
            pad: '',
            function: (value) => {
              if ((value || '').toLowerCase() === 'voided') {
                return 'C'
              } else {
                return 'I'
              }
            }
          },
          {
            name: 'account_number',
            length: 13,
            data: bank.account_number,
            pad: '',
            justify: 'right'
          },
          {
            name: 'check_number',
            length: 10,
            data: ['payment_confirmation_number', 'number'],
            pad: '',
            justify: 'right',
            function: (value) => {
              return value || ''
            }
          },
          {
            name: 'issue_date',
            length: 6,
            data: ['payment_date', 'date'],
            pad: '',
            justify: 'right',
            function: (value) => {
              const date = getSimpleDate(value)
              return date.substr(4, 2) + date.substr(6, 2) + date.substr(2, 2)
            }
          },
          {
            name: 'check_amount',
            length: 11,
            data: ['amount', 'amount_decimal'],
            pad: '',
            justify: 'right',
            function: (value) => {
              return parseFloat(value) > 99999999.99 ? 'XXXXXXXXXXX' : String(value || '')
            }
          },
          {
            name: 'additional_data',
            length: 30,
            pad: ' '
          }
        ]
      }

      // Now build data rows
      for (const i in data) {
        // If AP, only return checkdata, not wires
        // if (!data.account_cash && !(data[i].payment_type || '').toLowerCase().match(/check/)) continue

        let line = ''

        // Go through the mapping and transform data if necessary
        for (const j in map) {
          const field = map[j]
          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, data[i]) : data[i][field.data]) || (field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          line += pad(value, field.pad || '', field.length, field.justify)
          if (parseInt(j) < (map.length - 1)) line += ','
        }
        line += '\r\n'
        output += line
      }

      return output
    },

    coalesceArray (fields = null, data = null) {
      if (!fields) {
        return false
      } else if (data && !Array.isArray(fields)) {
        return data[fields] || fields
      } else if (!Array.isArray(fields)) {
        return fields
      }

      for (const i in fields) {
        if (!data && typeof fields[i] !== 'undefined') {
          return fields[i]
        } else if (typeof data[fields[i]] !== 'undefined' && data[fields[i]]) {
          return data[fields[i]]
        } else {
          continue
        }
      }

      return undefined
    },

    /* Create a CSV file for City National Bank NACHA format
     * NACHA FILE FORMAT contains multiple records.  Sample below
     *     File Header Record
     *         Batch Header Record
     *             Entry Detail Record
     *                 Addenda Record #1
     *                 Addenda Record #2
     *             Entry Detail Record
     *                 Addenda Record
     *         Batch Control Record
     *         Batch Header Record
     *             Entry Detail Record
     *             Entry Detail Record
     *         Batch Control Record
     *     File Control Record
     */
    async createAchCnb (resources = null, bank = null, verbose = false, paymentDate) {
      if (!resources || !bank || !Array.isArray(resources)) return false

      let company = this.$store.getters.getCompanies.find((comp) => comp.bank === bank.id)
      if (!company) {
        const batchId = ((((resources[0] || {}).attributes || {}).resources[0] || {}).attributes || {}).batch
        await this.$store.dispatch('fetchBatchesWithQuery', { id: batchId })
        company = this.$store.getters.getCompanyByBatchId(batchId)
      }

      // This is the final output
      let csv = ''
      let totalLineCounter = 0
      const batchCounter = 1
      let detailCounter = 0
      let creditTotal = 0
      let debitTotal = 0
      let detailEntryHash = 0

      // This is the fixed width template
      const fileHeaderRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '1'
        },
        {
          name: 'priority_code',
          length: 2,
          pad: null,
          default: '01'
        },
        {
          name: 'immediate_destination',
          data: bank.routing_number,
          length: 10,
          pad: ' ',
          // default: '122016066',
          justify: 'right'
        },
        {
          // Assigned by bank, but let's use account number for now
          name: 'immediate_origin',
          length: 10,
          data: bank.account_number,
          pad: '0',
          justify: 'left',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'file_create_date',
          length: 6,
          pad: null,
          function: () => {
            const date = getSimpleDate(new Date())
            return date.substr(2, 2) + date.substr(4, 2) + date.substr(6, 2)
          }
        },
        {
          name: 'file_create_time',
          length: 4,
          pad: null,
          function: () => {
            const date = new Date()
            return String(date.getHours()) + String(date.getMinutes())
          }
        },
        {
          name: 'file_id_modifier',
          length: 1,
          pad: null,
          default: 'A',
          function: (value) => {
            return value
          }
        },
        {
          name: 'record_size',
          length: 3,
          pad: null,
          default: '094'
        },
        {
          name: 'block_factor',
          length: 2,
          pad: null,
          default: '10'
        },
        {
          name: 'format_code',
          length: 1,
          pad: null,
          default: '1'
        },
        {
          name: 'immediate_destination_name',
          length: 23,
          pad: ' ',
          default: 'CITY NATIONAL BANK',
          justify: 'left'
        },
        {
          name: 'immediate_origin_name',
          length: 23,
          data: company.name,
          pad: ' ',
          default: 'unknown',
          justify: 'left',
          function: (value) => (value || '').toUpperCase()
        },
        {
          name: 'ref_code',
          length: 8,
          pad: ' '
        }
      ]

      const batchHeaderRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '5'
        },
        {
          name: 'service_class_code',
          length: 3,
          pad: null,
          default: '200'
        },
        {
          name: 'company_name',
          length: 16,
          data: company.name,
          pad: ' ',
          justify: 'left',
          function: (value) => (value || '').toUpperCase()
        },
        {
          name: 'company_discretion_data',
          length: 20,
          pad: ' '
        },
        {
          name: 'company_id',
          length: 10,
          data: bank.branch_number,
          pad: '0',
          default: 'UNKNOWN'
        },
        {
          name: 'standard_entry_class_code',
          length: 3,
          pad: ' ',
          justify: 'left',
          function: (value) => {
            return 'CCD'
          }
        },
        {
          name: 'company_entry_desc',
          length: 10,
          data: ['transaction_description'],
          default: 'Payments',
          pad: ' ',
          justify: 'left',
          function: (value) => (value || '').toUpperCase()
        },
        {
          name: 'company_descrip_date',
          length: 6,
          pad: ' '
        },
        {
          name: 'effective_entry_date',
          length: 6,
          pad: null,
          function: (value) => {
            // if date is too early, make one day past today
            const date = getSimpleDate(paymentDate)
            return date.substr(2, 2) + date.substr(4, 2) + date.substr(6, 2)
          }
        },
        {
          name: 'settlement_date',
          length: 3,
          pad: ' '
        },
        {
          name: 'origin_status_code',
          length: 1,
          pad: null,
          default: '1'
        },
        {
          name: 'origin_dfi_id',
          data: bank.routing_number,
          length: 8,
          pad: '0'
        },
        {
          name: 'batch_number',
          length: 7,
          pad: '0',
          function: () => batchCounter // counter
        }
      ]

      const entryDetailRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '6'
        },
        {
          name: 'transaction_code',
          data: ['amount', 'amount_decimal'],
          length: 2,
          pad: null,
          function: (value) => parseFloat(value) > 0 ? '22' : '27' // Checking credit : Checking debit ; can't handle savings accounts
        },
        {
          name: 'receiving_dfi_id',
          length: 9, // Should be 8 + the 1-digit check digit, but 9 makes so much more sense.
          data: 'ach_routing_number',
          pad: ' ',
          default: '123456789',
          function: (value) => (value || '').replace(/\D/g, '').substr(0, 9)
        },
        /*
        {
          name: 'check_digit',
          length: 1,
          data: ['ach_routing_number'],
          pad: '0',
          default: '',
          function: (value) => (value || '').replace(/\D/g, '').substr(8, 1)
        },
        */
        {
          name: 'dfi_account_number',
          length: 17,
          data: 'ach_account_number',
          pad: ' ',
          justify: 'left',
          // default: '0987654321',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'amount',
          length: 10,
          data: ['amount', 'amount_decimal'],
          pad: '0',
          justify: 'right',
          default: '',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'individual_identification_number',
          length: 15,
          data: 'code',
          pad: ' ',
          justify: 'left',
          // default: 'S9-me_Vendor*code',
          function: (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
        },
        {
          name: 'individual_name',
          length: 22,
          data: 'name',
          pad: ' ',
          // default: 'Mc\'in/osh (& 3-G *,Inc.)',
          justify: 'left',
          function: (value) => String(value || '').replace(/[^A-Za-z0-9./()& '-]/g, '')
        },
        {
          name: 'discretionary_data',
          length: 2,
          pad: ' '
        },
        {
          name: 'addenda_record_indicator',
          length: 1,
          pad: null,
          default: '0'
        },
        {
          name: 'trace_number',
          length: 15,
          pad: '0',
          default: '12201606',
          function: (value) => String(value) + pad(detailCounter, 0, 7)
        }
      ]

      const batchControlRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '8'
        },
        {
          name: 'service_class_code',
          length: 3,
          pad: null,
          default: '200'
        },
        {
          name: 'entry_addenda_count',
          length: 6,
          pad: '0',
          function: () => detailCounter
        },
        {
          name: 'entry_hash',
          length: 10,
          pad: '0',
          function: () => detailEntryHash
        },
        {
          name: 'total_debit_entry_dollar_amount',
          length: 12,
          pad: '0',
          default: '',
          function: () => String(debitTotal).replace(/\D/g, '')
        },
        {
          name: 'total_credit_entry_dollar_amount',
          length: 12,
          pad: '0',
          default: '',
          function: () => String(creditTotal).replace(/\D/g, '')
        },
        {
          name: 'company_id',
          length: 10,
          // data: bank.positivepay_username || 'UNKNOWN',
          data: bank.branch_number,
          pad: '0',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'message_authentication_code',
          length: 19,
          pad: ' '
        },
        {
          name: 'reserved',
          length: 6,
          pad: ' '
        },
        {
          name: 'originating_dfi_id',
          data: bank.routing_number,
          length: 8,
          pad: '0'
        },
        {
          name: 'batch_number',
          length: 7,
          pad: '0',
          function: () => batchCounter // counter
        }
      ]

      const fileControlRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '9'
        },
        {
          name: 'batch_count',
          length: 6,
          pad: '0',
          function: () => batchCounter
        },
        {
          name: 'block_count',
          length: 6,
          pad: '0',
          function: () => Math.ceil(totalLineCounter / 10)
        },
        {
          name: 'entry_addenda_count',
          length: 8,
          pad: '0',
          function: () => detailCounter
        },
        {
          name: 'entry_hash',
          length: 10,
          pad: '0',
          function: () => detailEntryHash
        },
        {
          name: 'total_debit_entry_dollar_amount_in_file',
          length: 12,
          pad: '0',
          function: () => String(debitTotal).replace(/\D/g, '')
        },
        {
          name: 'total_credit_entry_dollar_amount_in_file',
          length: 12,
          pad: '0',
          function: () => String(creditTotal).replace(/\D/g, '')
        },
        {
          name: 'reserved',
          length: 39,
          pad: ' '
        }
      ]

      const generateHeaderControlLine = (type = null, verbose = false) => {
        let line = ''
        if (!type) return line

        // Go through the mapping and transform data if necessary
        for (const i in type) {
          const field = type[i]
          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, resources[i]) : field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          line += pad(value, field.pad || '', field.length, field.justify)
        }
        totalLineCounter++
        let headerLine = ''
        if (verbose) headerLine += pad(totalLineCounter, ' ', 4, 'left')
        headerLine += line
        headerLine += '\r\n'
        return headerLine
      }

      const generateDetailLines = async (verbose = false) => {
        let detailLines = ''
        for (const i in resources) {
          let line = ''
          const vendorId = resources[i].attributes.vendor
          let vendor = this.$store.getters.getVendorById(vendorId)
          if (!vendor.id) {
            await this.$store.dispatch('fetchVendorById', vendorId)
            vendor = this.$store.getters.getVendorById(vendorId)
          }
          if (!vendor) continue
          detailCounter++
          const entryHash = parseFloat(String(vendor.ach_routing_number || '0').substr(0, 8))
          detailEntryHash += entryHash

          // Go through the mapping and transform data if necessary
          for (const j in entryDetailRecord) {
            const field = entryDetailRecord[j]
            let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, resources[i].attributes) : vendor[field.data] || resources[i].attributes[field.data]) || field.default || ''
            if (field.hasOwnProperty('function') && typeof field.function === 'function') {
              value = field.function(value || '') || ''
            }
            line += pad(value, field.pad || '', field.length, field.justify)
          }
          line += '\r\n'

          // totals
          debitTotal += resources[i].attributes.amount_decimal > 0 ? parseFloat(resources[i].attributes.amount_decimal) : 0
          creditTotal += resources[i].attributes.amount_decimal < 0 ? parseFloat(resources[i].attributes.amount_decimal) * -1 : 0
          totalLineCounter++
          if (verbose) detailLines += pad(totalLineCounter, ' ', 4, 'left')
          detailLines += line
        }
        return detailLines
      }

      if (verbose) csv += this.showColumnNumbers()
      csv += generateHeaderControlLine(fileHeaderRecord, verbose)
      csv += generateHeaderControlLine(batchHeaderRecord, verbose)
      csv += await generateDetailLines(verbose)
      csv += generateHeaderControlLine(batchControlRecord, verbose)
      csv += generateHeaderControlLine(fileControlRecord, verbose)
      csv = this.addBlockingLines(csv, totalLineCounter, verbose)
      if (verbose) csv += this.showColumnNumbers()

      return csv
    },

    /* Create a CSV file for JP MORGAN CHASE Bank NACHA format
     * NACHA FILE FORMAT contains multiple records.  Sample below
     *     File Header Record
     *         Batch Header Record
     *             Entry Detail Record
     *                 Addenda Record #1
     *                 Addenda Record #2
     *             Entry Detail Record
     *                 Addenda Record
     *         Batch Control Record
     *         Batch Header Record
     *             Entry Detail Record
     *             Entry Detail Record
     *         Batch Control Record
     *     File Control Record
     */
    async createAchJpmc (resources = null, bank = null, verbose = false, paymentDate) {
      if (!resources || !bank || !Array.isArray(resources)) return false

      let company = this.$store.getters.getCompanies.find((comp) => comp.bank === bank.id)
      if (!company) {
        const batchId = ((((resources[0] || {}).attributes || {}).resources[0] || {}).attributes || {}).batch
        await this.$store.dispatch('fetchBatchesWithQuery', { id: batchId })
        company = this.$store.getters.getCompanyByBatchId(batchId)
      }

      // This is the final output
      let csv = ''
      let totalLineCounter = 0
      const batchCounter = 1
      let detailCounter = 0
      let creditTotal = 0
      let debitTotal = 0
      let detailEntryHash = 0

      // This is the fixed width template
      const fileHeaderRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '1'
        },
        {
          name: 'priority_code',
          length: 2,
          pad: null,
          default: '01'
        },
        {
          name: 'immediate_destination',
          data: bank.routing_number,
          length: 10,
          pad: ' ',
          justify: 'right'
        },
        {
          // Assigned by bank, but let's use account number for now
          name: 'immediate_origin',
          length: 10,
          data: '0000000000',
          pad: '0',
          justify: 'left'
        },
        {
          name: 'file_create_date',
          length: 6,
          pad: null,
          function: () => {
            const date = getSimpleDate(new Date())
            return date.substr(2, 2) + date.substr(4, 2) + date.substr(6, 2)
          }
        },
        {
          name: 'file_create_time',
          length: 4,
          pad: '0',
          function: () => {
            const date = new Date()
            let mins = date.getMinutes()
            if (mins < 10) {
              mins = '0' + mins
            }
            return String(date.getHours()) + String(mins)
          }
        },
        {
          name: 'file_id_modifier',
          length: 1,
          pad: null,
          default: '1',
          function: (value) => {
            return value
          }
        },
        {
          name: 'record_size',
          length: 3,
          pad: null,
          default: '094'
        },
        {
          name: 'block_factor',
          length: 2,
          pad: null,
          default: '10'
        },
        {
          name: 'format_code',
          length: 1,
          pad: null,
          default: '1'
        },
        {
          name: 'immediate_destination_name',
          length: 23,
          pad: ' ',
          default: 'JP MORGAN CHASE',
          justify: 'left'
        },
        {
          name: 'immediate_origin_name',
          length: 23,
          pad: ' ',
          default: 'REVOLUTION STUDIO LLC',
          justify: 'left',
          function: (value) => (value || '').toUpperCase()
        },
        {
          name: 'ref_code',
          length: 8,
          pad: ' '
        }
      ]

      const batchHeaderRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '5'
        },
        {
          name: 'service_class_code',
          length: 3,
          pad: null,
          default: '220'
        },
        {
          name: 'company_name',
          length: 16,
          data: 'REVOLUTION STUDI',
          pad: ' ',
          justify: 'left'
        },
        {
          name: 'company_discretion_data',
          length: 20,
          data: '0' + bank.account_number,
          pad: '0'
        },
        {
          name: 'company_id',
          length: 10,
          data: bank.branch_number,
          pad: '0',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'standard_entry_class_code',
          length: 3,
          data: 'CCD',
          pad: null,
          justify: 'left'
        },
        {
          name: 'company_entry_desc',
          length: 10,
          pad: ' ',
          justify: 'left',
          default: 'Payment',
          function: (value) => (value || '').toUpperCase()
        },
        {
          name: 'company_descrip_date',
          length: 6,
          pad: null,
          function: (value) => {
            const date = new Date()
            return date.toLocaleString('default', {month: 'short', year: '2-digit'})
          }
        },
        {
          name: 'effective_entry_date',
          length: 6,
          pad: '0',
          function: (value) => {
            // if date is too early, make one day past today
            const date = getSimpleDateWithNextBusinessDay(paymentDate)
            return date.substr(2, 2) + date.substr(4, 2) + date.substr(6, 2)
          }
        },
        {
          name: 'settlement_date',
          length: 3,
          pad: ' '
        },
        {
          name: 'origin_status_code',
          length: 1,
          pad: null,
          default: '1'
        },
        {
          name: 'origin_dfi_id',
          data: bank.routing_number,
          length: 8,
          pad: null
        },
        {
          name: 'batch_number',
          length: 7,
          pad: '0',
          function: () => batchCounter // counter
        }
      ]

      const entryDetailRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '6'
        },
        {
          name: 'transaction_code',
          data: ['amount', 'amount_decimal'],
          length: 2,
          pad: null,
          function: (value) => parseFloat(value) > 0 ? '22' : '27' // Checking credit : Checking debit ; can't handle savings accounts
        },
        {
          name: 'receiving_dfi_id',
          length: 8, // Should be 8 + the 1-digit check digit, but 9 makes so much more sense.
          data: 'ach_routing_number',
          pad: ' ',
          default: '123456789',
          function: (value) => (value || '').replace(/\D/g, '').substr(0, 9)
        },
        {
          name: 'check_digit',
          length: 1,
          data: 'ach_routing_number',
          pad: '0',
          default: '',
          function: (value) => (value || '').replace(/\D/g, '').substr(8, 1)
        },
        {
          name: 'dfi_account_number',
          length: 17,
          data: 'ach_account_number',
          pad: ' ',
          justify: 'left',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'amount',
          length: 10,
          data: ['amount', 'amount_decimal'],
          pad: '0',
          justify: 'right',
          default: '',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'individual_identification_number',
          length: 15,
          data: 'code',
          pad: ' ',
          justify: 'left',
          function: (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '')
        },
        {
          name: 'individual_name',
          length: 22,
          data: 'name',
          pad: ' ',
          justify: 'left',
          function: (value) => String(value || '').replace(/[^A-Za-z0-9./()& '-]/g, '')
        },
        {
          name: 'discretionary_data',
          length: 2,
          pad: ' '
        },
        {
          name: 'addenda_record_indicator',
          length: 1,
          pad: null,
          default: '0'
        },
        {
          name: 'trace_number',
          length: 15,
          pad: '0',
          default: '12201606',
          function: (value) => String(value) + pad(detailCounter, 0, 7)
        }
      ]

      const batchControlRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '8'
        },
        {
          name: 'service_class_code',
          length: 3,
          pad: null,
          default: '220'
        },
        {
          name: 'entry_addenda_count',
          length: 6,
          pad: '0',
          function: () => detailCounter
        },
        {
          name: 'entry_hash',
          length: 10,
          pad: '0',
          function: () => detailEntryHash
        },
        {
          name: 'total_debit_entry_dollar_amount',
          length: 12,
          pad: '0',
          default: '',
          function: () => String(debitTotal.toFixed(2)).replace(/\D/g, '')
        },
        {
          name: 'total_credit_entry_dollar_amount',
          length: 12,
          pad: '0',
          default: '',
          function: () => String(creditTotal.toFixed(2)).replace(/\D/g, '')
        },
        {
          name: 'company_id',
          length: 10,
          data: bank.branch_number,
          pad: '0',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'message_authentication_code',
          length: 19,
          pad: ' ',
          default: ''
        },
        {
          name: 'reserved',
          length: 6,
          pad: ' ',
          default: ''
        },
        {
          name: 'originating_dfi_id',
          data: bank.routing_number,
          length: 8,
          pad: '0'
        },
        {
          name: 'batch_number',
          length: 7,
          pad: '0',
          function: () => batchCounter // counter
        }
      ]

      const fileControlRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '9'
        },
        {
          name: 'batch_count',
          length: 6,
          pad: '0',
          default: '1'
        },
        {
          name: 'block_count',
          length: 6,
          pad: '0',
          function: () => Math.ceil(totalLineCounter / 10)
        },
        {
          name: 'entry_addenda_count',
          length: 8,
          pad: '0',
          function: () => detailCounter
        },
        {
          name: 'entry_hash',
          length: 10,
          pad: '0',
          function: () => detailEntryHash
        },
        {
          name: 'total_debit_entry_dollar_amount_in_file',
          length: 12,
          pad: '0',
          function: () => String(debitTotal.toFixed(2)).replace(/\D/g, '')
        },
        {
          name: 'total_credit_entry_dollar_amount_in_file',
          length: 12,
          pad: '0',
          function: () => String(creditTotal.toFixed(2)).replace(/\D/g, '')
        },
        {
          name: 'reserved',
          length: 39,
          pad: ' '
        }
      ]

      const generateHeaderControlLine = (type = null, verbose = false) => {
        let line = ''
        if (!type) return line

        // Go through the mapping and transform data if necessary
        for (const i in type) {
          const field = type[i]
          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, resources[i]) : field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          line += pad(value, field.pad || '', field.length, field.justify)
        }
        totalLineCounter++
        let headerLine = ''
        if (verbose) headerLine += pad(totalLineCounter, ' ', 4, 'left')
        headerLine += line
        headerLine += '\r\n'
        return headerLine
      }

      const generateDetailLines = async (verbose = false) => {
        let detailLines = ''
        for (const i in resources) {
          let line = ''
          const vendorId = resources[i].attributes.vendor
          let vendor = this.$store.getters.getVendorById(vendorId)
          if (!vendor.id) {
            await this.$store.dispatch('fetchVendorById', vendorId)
            vendor = this.$store.getters.getVendorById(vendorId)
          }
          if (!vendor) continue
          detailCounter++
          const entryHash = parseFloat(String(vendor.ach_routing_number || '0').substr(0, 8))
          detailEntryHash += entryHash

          // Go through the mapping and transform data if necessary
          for (const j in entryDetailRecord) {
            const field = entryDetailRecord[j]
            let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, resources[i].attributes) : vendor[field.data] || resources[i].attributes[field.data]) || field.default || ''
            if (field.hasOwnProperty('function') && typeof field.function === 'function') {
              value = field.function(value || '') || ''
            }
            line += pad(value, field.pad || '', field.length, field.justify)
          }
          line += '\r\n'

          // totals
          creditTotal += resources[i].attributes.amount_decimal > 0 ? parseFloat(resources[i].attributes.amount_decimal) : 0
          debitTotal += resources[i].attributes.amount_decimal < 0 ? parseFloat(resources[i].attributes.amount_decimal) * -1 : 0
          totalLineCounter++
          if (verbose) detailLines += pad(totalLineCounter, ' ', 4, 'left')
          detailLines += line
        }
        return detailLines
      }

      if (verbose) csv += this.showColumnNumbers()
      csv += generateHeaderControlLine(fileHeaderRecord, verbose)
      csv += generateHeaderControlLine(batchHeaderRecord, verbose)
      csv += await generateDetailLines(verbose)
      csv += generateHeaderControlLine(batchControlRecord, verbose)
      csv += generateHeaderControlLine(fileControlRecord, verbose)
      csv = this.addBlockingLines(csv, totalLineCounter, verbose)
      if (verbose) csv += this.showColumnNumbers()

      return csv
    },

    // Create a CSV file for Wells Fargo Manual upload
    // Array keys will be the column headers
    createArpWellsManual (data, bank, map) {
      // if (!data || !Array.isArray(data)) return false

      // This is the final output
      let csv = ''

      // This is the fixed width template
      if (!map) {
        map = [
          {
            name: 'bank_routing_number',
            data: bank.routing_number
          },
          {
            name: 'bank_account_number',
            data: bank.account_number
          },
          {
            name: 'check_number',
            length: 8,
            data: ['payment_confirmation_number', 'number'],
            pad: '0'
          },
          {
            name: 'issue_date',
            length: 10,
            data: ['payment_date', 'date'],
            pad: null,
            function: (value) => {
              const date = getSimpleDate(value)
              return date.substr(4, 2) + '-' + date.substr(6, 2) + '-' + date.substr(0, 4)
            }
          },
          {
            name: 'check_amount',
            data: ['amount', 'amount_decimal'],
            pad: '',
            function: (value) => {
              return (value || '').replace(/[^0-9.]/g, '')
            }
          },
          {
            name: 'status_indicator',
            data: 'status',
            length: 3,
            pad: null,
            function: (value) => {
              if ((value || '').toLowerCase() === 'voided') {
                return '370'
              } else {
                return '320'
              }
            }
          },
          {
            name: 'payee_name',
            length: 50,
            data: ['payee_name', 'vendor_name'],
            function: (value) => {
              return (value.toString() || '').replace(/,/g, '')
            }
          }
        ]
      }

      // Now build data rows
      for (const i in data) {
        // If AP, only return checkdata, not wires
        let line = ''
        const lineData = []

        // Go through the mapping and transform data if necessary
        for (const j in map) {
          const field = map[j]

          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, data[i]) : data[i][field.data]) || (field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          lineData.push(pad(value, field.pad || '', field.length, field.justify))
        }
        line += lineData.join(',')
        line += '\r\n'
        csv += line
      }

      return csv
    },

    /* Create a FIXED WIDTH Positive Pay (ARP) file for WELLS Fargo
     *     File Header Record
     *       Entry Detail Record
     *     Trailer Record
     * UNTESTED.  HERE FOR FUTURE POSSIBLE USE
     */
    async createArpWellsFixed (resources = null, bank = null, verbose = false) {
      if (!resources || !bank || !Array.isArray(resources)) return false

      // This is the final output
      let csv = ''
      let totalLineCounter = 0
      let detailCounter = 0
      let total = 0

      // This is the fixed width template
      const fileHeaderRecord = [
        {
          name: 'record_type_code',
          length: 3,
          pad: null,
          default: '*03'
        },
        {
          name: 'bank_id',
          length: 5,
          data: bank.branch_number,
          pad: '0',
          justify: 'right',
          default: 'UNKNOWN'
        },
        {
          name: 'account_number',
          length: 15,
          data: 'account_number',
          justify: 'right',
          pad: '0',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'file_status',
          length: 1,
          pad: null,
          default: '0'
        },
        {
          name: 'unused',
          length: 61,
          pad: ' ',
          default: ' ',
          justify: 'right'
        }
      ]

      const entryDetailRecord = [
        {
          name: 'check_number',
          length: 10,
          data: ['payment_confirmation_number', 'number'],
          pad: '0',
          justify: 'right'
        },
        {
          name: 'issue_date',
          length: 6,
          data: ['payment_date', 'date'],
          pad: null,
          function: (value) => {
            const date = getSimpleDate(value)
            return date.substr(4, 2) + date.substr(6, 2) + date.substr(2, 2)
          }
        },
        {
          name: 'account_number',
          length: 15,
          data: 'account_number',
          justify: 'right',
          pad: '0',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'transaction_code',
          data: ['amount', 'amount_decimal'],
          length: 3,
          pad: null,
          function: (value) => parseFloat(value) > 0 ? '320' : '370' // Checking credit : Checking debit ; can't handle savings accounts
        },
        {
          name: 'amount',
          length: 10,
          data: ['amount', 'amount_decimal'],
          pad: '0',
          justify: 'right',
          default: '',
          function: (value) => (value || '').replace(/\D/g, '')
        },
        {
          name: 'individual_name',
          length: 40,
          data: 'name',
          pad: ' ',
          // default: 'Mc\'in/osh (& 3-G *,Inc.)',
          justify: 'left',
          function: (value) => String(value || '').replace(/[^A-Za-z0-9./()& '-]/g, '')
        },
        {
          name: 'spaces3',
          length: 47,
          pad: ' ',
          default: ''
        }
      ]

      const trailerRecord = [
        {
          name: 'record_type_code',
          length: 1,
          pad: null,
          default: '&'
        },
        {
          name: 'spaces',
          length: 14,
          pad: ' ',
          default: ''
        },
        {
          name: 'entry_count',
          length: 7,
          pad: '0',
          function: () => detailCounter
        },
        {
          name: 'spaces2',
          length: 3,
          pad: ' ',
          default: ''
        },
        {
          name: 'total_debit_entry_dollar_amount_in_file',
          length: 12,
          pad: '0',
          function: () => String(total).replace(/\D/g, '')
        },
        {
          name: 'spaces3',
          length: 47,
          pad: ' ',
          default: ''
        }
      ]

      const generateHeaderControlLine = (type = null, verbose = false) => {
        let line = ''
        if (!type) return line

        // Go through the mapping and transform data if necessary
        for (const i in type) {
          const field = type[i]
          let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, resources[i]) : field.data) || field.default || ''
          if (field.hasOwnProperty('function') && typeof field.function === 'function') {
            value = field.function(value || '')
          }
          line += pad(value, field.pad || '', field.length, field.justify)
        }
        totalLineCounter++
        let headerLine = ''
        if (verbose) headerLine += pad(totalLineCounter, ' ', 4, 'left')
        headerLine += line
        headerLine += '\r\n'
        return headerLine
      }

      const generateDetailLines = async (verbose = false) => {
        let detailLines = ''
        for (const i in resources) {
          let line = ''

          const vendorId = (resources[i].attributes || {}).vendor
          if (!vendorId) continue

          let vendor = this.$store.getters.getVendorById(vendorId)
          if (!vendor.id) {
            await this.$store.dispatch('fetchVendorById', vendorId)
            vendor = this.$store.getters.getVendorById(vendorId)
          }
          if (!vendor) continue
          detailCounter++

          // Go through the mapping and transform data if necessary
          for (const j in entryDetailRecord) {
            const field = entryDetailRecord[j]
            let value = (Array.isArray(field.data) ? this.coalesceArray(field.data, resources[i].attributes) : vendor[field.data] || resources[i].attributes[field.data]) || field.default || ''
            if (field.hasOwnProperty('function') && typeof field.function === 'function') {
              value = field.function(value || '') || ''
            }
            line += pad(value, field.pad || '', field.length, field.justify)
          }
          line += '\r\n'

          // totals
          total += parseFloat(resources[i].attributes.amount_decimal) || 0
          totalLineCounter++
          if (verbose) detailLines += pad(totalLineCounter, ' ', 4, 'left')
          detailLines += line
        }
        return detailLines
      }

      if (verbose) csv += this.showColumnNumbers()
      csv += generateHeaderControlLine(fileHeaderRecord, verbose)
      csv += await generateDetailLines(verbose)
      csv += generateHeaderControlLine(trailerRecord, verbose)
      csv = this.addBlockingLines(csv, totalLineCounter, verbose)
      if (verbose) csv += this.showColumnNumbers()

      return csv
    },

    // Quick way to show numbers on the screen for easier debugging
    showColumnNumbers (length = 100, padding = 4) {
      let onesUnits = pad('', ' ', padding, 'left')
      let tensUnits = pad('', ' ', padding, 'left')
      let hundredsUnits = pad('', ' ', padding, 'left')
      for (let i = 1; i <= length; i++) {
        onesUnits += String(i).substr(-1, 1)
        tensUnits += (i % 10) ? ' ' : String(i).slice(0, -1).substr(-1, 1)
        hundredsUnits += (i % 100) ? ' ' : String(i).slice(0, -2).substr(-1, 1)
      }

      return hundredsUnits + '\r\n' + tensUnits + '\r\n' + onesUnits + '\r\n' + '\r\n'
    },

    // After all lines are generated, need to make sure the total amount of all lines (including batch/control/header/detail records) is a factor of 10, e.g. if there are 17 lines, add 3 fillers so that are 20 lines.
    addBlockingLines (csv = null, numLines = 0, verbose = false, blockingFactor = 10) {
      if (!csv || numLines === 0 || blockingFactor === 0) return null
      if (!blockingFactor) blockingFactor = 10
      const addLines = blockingFactor - (numLines % blockingFactor)
      if (addLines <= 0) return csv
      for (let i = 0; i < addLines; i++) {
        numLines++
        const filler = '9999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999999'
        if (verbose) csv += pad(numLines, ' ', 4, 'left')
        csv += filler
        csv += '\r\n'
      }
      return csv
    }
  }
}



// WEBPACK FOOTER //
// ./src/Mixins/PositivePay.js